import { createContext, useContext } from "react";

// Uniform auth surface the app codes against, regardless of whether Cognito (production) or the
// dev-session cookie (local) backs it.
export interface AppAuth {
  isLoaded: boolean;
  isSignedIn: boolean;
  displayName: string | null;
  /** Bearer token for the API (cc-patient audience), or null when a session cookie is used. */
  getToken: () => Promise<string | null>;
  signOut: () => Promise<void> | void;
  /** Update the identity name held by the auth provider (Cognito `given_name`/`family_name`) so
   *  name displays sourced from auth — the top-bar chip — refresh reactively after a profile save.
   *  No-op where the app backend is the only name source (dev). */
  updateProfile?: (p: { firstName: string; lastName: string }) => Promise<void>;
  /** Dev-only convenience sign-in (cookie). Undefined when Cognito is enabled. */
  devSignIn?: () => Promise<void>;
}

export const AuthContext = createContext<AppAuth | null>(null);

export function useAppAuth(): AppAuth {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAppAuth must be used within an AuthProvider");
  return ctx;
}
